import {handleActions} from 'redux-actions';
import { clearAssessmentForm,
  changeAssessmentName,
  changeSubsectionTitle,
  removeSubsection,
  addSubsection,
  addQuestion,
  removeQuestion,
  updateQuestion } from '../actions/createAssessment';
import _ from 'lodash';

const initialState = {
  assessment: {
    name: '',
    subsections: [],
  }
};

const createAssessment = handleActions(
  {
    [clearAssessmentForm]: () => ({ ...initialState }),
    [changeAssessmentName]: (state, action) => ({ ...state, assessment: { ...state.assessment, name: action.payload.value }}),
    [addSubsection]: state => ({
      ...state,
      assessment: {
        ...state.assessment,
        subsections: [
          ...state.assessment.subsections,
          { name: `Subsection ${state.assessment.subsections.length + 1}`}
        ]
      }
    }),
    [removeSubsection]: (state, action) => ({
      ...state,
      assessment: {
        ...state.assessment,
        subsections: state.assessment.subsections.filter((ss, i) => i !== action.payload)
      }
    }),
    [changeSubsectionTitle]: (state, action) => {
      let nextState = _.cloneDeep(state);
      nextState.assessment.subsections[action.payload.index] = {
        ...nextState.assessment.subsections[action.payload.index],
        name: action.payload.value
      };
      return nextState;
    },
    [addQuestion]: (state, action) => {
      let newState = _.cloneDeep(state);
      newState.assessment.subsections[action.payload.subId].questions = [...(newState.assessment.subsections[action.payload.subId].questions || []), action.payload.question];
      return newState;
    },
    [removeQuestion]: (state, action) => {
      let newState = _.cloneDeep(state);
      newState.assessment.subsections[action.payload.subId].questions.splice(action.payload.qId, 1);
      return newState;
    },
    [updateQuestion]: (state, action) => {
      let newState = _.cloneDeep(state);
      newState.assessment.subsections[action.payload.subId].questions[action.payload.qId] = action.payload.question;
      return newState;
    }
  },
  initialState
);

export default createAssessment;


// WEBPACK FOOTER //
// ./src/components/utils/reducers/createAssessment.js